import { Skeleton, cn } from "ui";

type SkeletonButtonProps = {
  className?: string;
};

export const SkeletonButton = ({ className }: SkeletonButtonProps) => (
  <Skeleton className={cn("h-10 w-24", className)} />
);
